// SPDX-License-Identifier: AGPL-3.0-or-later

import {useUserActivities} from '@app/features/presence/hooks/useUserActivities';
import Presence from '@app/features/presence/state/Presence';
import {http} from '@app/features/platform/transport/RestTransport';
import type {Activity} from '@fluxer/schema/src/domains/gateway/ActivitySchemas';
import {observer} from 'mobx-react-lite';
import React, {useEffect} from 'react';
import {RichPresenceCard} from './RichPresenceCard';

interface RichPresenceSectionProps {
	userId: string;
}

export const RichPresenceSection: React.FC<RichPresenceSectionProps> = observer(({userId}) => {
	const activities = useUserActivities(userId);

	useEffect(() => {
		let cancelled = false;
		const fetchActivities = () => {
			http.get<{activities?: Array<Activity>}>('/users/' + userId + '/activities')
				.then((res) => {
					if (cancelled) return;
					const acts = res.body?.activities;
					if (acts && acts.length > 0) {
						Presence.activities.set(userId, acts);
						Presence.bumpPresenceVersion();
					} else if (activities.length > 0) {
						Presence.activities.delete(userId);
						Presence.bumpPresenceVersion();
					}
				})
				.catch(() => {});
		};

		fetchActivities();
		const interval = setInterval(fetchActivities, 5000);

		return () => {
			cancelled = true;
			clearInterval(interval);
		};
	}, [userId, activities.length]);

	if (!activities || activities.length === 0) {
		return null;
	}

	return (
		<div data-flx="user.profile.rich-presence-section.wrapper">
			{activities.map((activity, index) => (
				<RichPresenceCard
					key={`${activity.name}:${index}`}
					activity={activity}
				/>
			))}
		</div>
	);
});
